import React from 'react';
import PropTypes from 'prop-types';
import bootstrap from 'bootstrap/dist/css/bootstrap.css';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from '../../../assets/styles/style.sass';
import s2 from '../../order/Order.sass';

import imgUserAvator from '../../../assets/img/icon_avatar.png';
import imgUserAvator2 from '../../../assets/img/icon_avatar@2x.png';
import imgPhone from '../../../assets/img/icon_phone.png';
import imgPhone2 from '../../../assets/img/icon_phone@2x.png';

class OrderSummary08ReceiverInfo extends React.Component {
  static propTypes = {
    orderDetailInfo: PropTypes.shape().isRequired,
    modelDataText: PropTypes.shape().isRequired,
  };

  render() {
    return (
      <div className={`${s.summarySender}`}>
        <p className={s2.orderSmallTitle}>
          {this.props.modelDataText.contact_info_title}
        </p>
        <hr className={s2.hrBottom} />
        <div className={`${s.summarySender}`}>
          <p>
            <img
              className={s2.orderSummaryIcon}
              srcSet={`${imgUserAvator} 1x, ${imgUserAvator2} 2x`}
              width="24"
              alt="user"
            />
            <span>
              {
                this.props.orderDetailInfo.order_request_extra_attributes
                  .receiver_name
              }
            </span>
          </p>
          <p>
            <img
              className={s2.orderSummaryIcon}
              srcSet={`${imgPhone} 1x, ${imgPhone2} 2x`}
              width="24"
              alt="phone"
            />
            <span>
              {
                this.props.orderDetailInfo.order_request_extra_attributes
                  .receiver_phone_number
              }
            </span>
          </p>
        </div>
      </div>
    );
  }
}
const mapState = state => ({
  currentLocale: state.intl.locale,
  address: state.order.address,
  remark: state.order.remark,
  passengerCount: state.order.passenger_count,
  tunnel: state.order.tunnel,
  images: state.order.images,
  vehicle: state.order.vehicle,
  pickupTime: state.order.pickup_time,
  orderPriceBreakdownDetail: state.order.orderPriceBreakdownDetail,
  orderDetailInfo: state.order.orderDetailInfo,
});
export default connect(mapState)(
  withStyles(bootstrap, s, s2)(OrderSummary08ReceiverInfo),
);



// WEBPACK FOOTER //
// ./src/routes/OrderSummary/OrderSummary08ReceiverInfo/OrderSummary08ReceiverInfo.js